enum EUserType {
  Accountant = 'accountant',
  Admin = 'admin',
  Owner = 'owner',
  Technician = 'technician',
}

export default EUserType;
